import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-json-view-page',
  templateUrl: './json-view-page.component.html',
  styleUrls: ['./json-view-page.component.scss']
})
export class JsonViewPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
